import { gql } from '@apollo/client'

export const GET_WAGON_WHEEL_DATA = gql`
query GetWagonsData($input: getWagonsDataInput) {
  getWagonsData(input: $input) {
    runs {
      offSide
      onSide
      total
      types {
        type
        list {
          nXcord
          nYcord
        }
        count
      }
    }
    zones {
      runsScored
      zone
    }
    isCoordinate
    isZone
  }
}
`
